import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../root-route";
import { HomePage } from "./home";

/**
 * Routes de l'app. Fichier possede par l'app : ajoute ici tes pages, le template
 * ne reecrira pas ce fichier (_skip_if_exists).
 */
export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
});

export const appRoutes = [homeRoute];
